
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comedy",
      function () {
        return require("private-next-pages/comedy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comedy"])
      });
    }
  